import { createFileRoute } from "@tanstack/react-router";
import { useSession } from "@/hooks/use-session";
import { CallListManager } from "@/components/call-time/call-list-manager";

export const Route = createFileRoute("/_app/_/call-time/manage")({
	component: CallListManagePage,
});

function CallListManagePage() {
	const session = useSession();
	const campaignId = session.campaign?.id;

	if (!campaignId) {
		return (
			<div className="flex min-h-[50vh] items-center justify-center">
				<p className="text-muted-foreground">Loading campaign...</p>
			</div>
		);
	}

	return (
		<div className="mx-auto max-w-5xl space-y-6 p-6">
			<CallListManager campaignId={campaignId} />
		</div>
	);
}
